/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
var _16 = {
  "elem": "svg",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 32 32",
    "fill": "currentColor",
    "width": 16,
    "height": 16
  },
  "content": [{
    "elem": "path",
    "attrs": {
      "stroke-width": "0",
      "d": "m2.9806,29c-.5692,0-.979-.4772-.9806-1-.0005-.1628.0388-.3299.1249-.4885L15.1444,3.5248c.1865-.3435.521-.5248.8555-.5248s.6694.1812.8559.5248l13.0195,23.9867c.0861.1586.1251.3257.1246.4885-.0016.5228-.4111,1-.9803,1H2.9806Z"
    }
  }],
  "name": "triangle--solid",
  "size": 16
};

export { _16 as default };
